import { Box, IconButton, InputAdornment, makeStyles } from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { useThemeBreakpoints } from "api";
import { Form, Formik, FormikHelpers } from "formik";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ExtendedFirebaseInstance, useFirebase } from "react-redux-firebase";
import { Link, Redirect } from "react-router-dom";
import { RootState } from "redux/model";
import {
    InputFieldFormik,
    SubmitButton,
    Subtitle,
    Title,
} from "ui/componentes";
import { Message } from "ui/componentes/Message";

const useStyles = makeStyles((theme) => ({
    marginTop: {
        marginTop: theme.spacing(2),
    },
    marginLeft: {
        marginLeft: theme.spacing(1),
    },
}));

const initialValues = {
    email: "",
    password: "",
};

const onSubmit = (firebase: ExtendedFirebaseInstance, dispatch) => (
    values,
    { setSubmitting }: FormikHelpers<any>
) => {
    firebase
        .login(values)
        .then(() => {
            dispatch({ type: "LOGIN_SUCCESS" });
            setSubmitting(false);
        })
        .catch((error) => {
            dispatch({ type: "LOGIN_ERROR", data: error });
            setSubmitting(false);
        });
};

const SignIn = () => {
    const [showPassword, setShowPassword] = useState(false);
    const classes = useStyles();
    const { auth } = useSelector((state: RootState) => state.firebase);
    const { authError } = useSelector(
        (state: RootState) => state.authAppReducer
    );
    const firebase = useFirebase();
    const dispatch = useDispatch();
    const { isDownXs } = useThemeBreakpoints();

    if (auth.uid) {
        return <Redirect to="/" />;
    }

    return (
        <Box
            id="signIn"
            width="100%"
            height="100vh"
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            bgcolor="#F5F5F5"
        >
            <img
                src={`${process.env.PUBLIC_URL}/img/irb_logo.png`}
                style={{ maxHeight: isDownXs ? 100 : 120 }}
                alt="logo_irb"
            />
            <Formik
                initialValues={initialValues}
                onSubmit={onSubmit(firebase, dispatch)}
            >
                {() => (
                    <Form>
                        <Box minWidth={320} maxWidth={600} padding={3}>
                            <Message
                                message={authError}
                                variant="error"
                                show={!!authError}
                            />
                            <Title text="Login" className={classes.marginTop} />
                            <InputFieldFormik
                                required
                                autoFocus
                                id="email"
                                name="email"
                                label="Email"
                                margin="normal"
                                className={classes.marginTop}
                            />
                            <InputFieldFormik
                                required
                                id="password"
                                name="password"
                                label="Senha"
                                type={showPassword ? "text" : "password"}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={() =>
                                                    setShowPassword(
                                                        !showPassword
                                                    )
                                                }
                                                onMouseDown={(e) =>
                                                    e.preventDefault()
                                                }
                                            >
                                                {showPassword ? (
                                                    <Visibility />
                                                ) : (
                                                    <VisibilityOff />
                                                )}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                                margin="normal"
                                className={classes.marginTop}
                            />
                            <SubmitButton
                                fullWidth
                                size="large"
                                className={classes.marginTop}
                            >
                                Entrar
                            </SubmitButton>
                            <Box display="flex" marginTop={2}>
                                <Link to="auth/forgetPassword">
                                    <Subtitle
                                        text="Esqueceu a senha?"
                                        color="primary"
                                    />
                                </Link>
                            </Box>
                        </Box>
                    </Form>
                )}
            </Formik>
        </Box>
    );
};

export { SignIn };
